import { render, staticRenderFns } from "./CarbonEmissions.vue?vue&type=template&id=314fdb9e&scoped=true&"
import script from "./CarbonEmissions.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CarbonEmissions.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CarbonEmissions.vue?vue&type=style&index=0&id=314fdb9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314fdb9e",
  null
  
)

export default component.exports